export default "__VITE_ASSET__da5bf75e__"